import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { T } from 'src/assets/i18n/translation-keys';

@Component({
    selector: 'app-list-count',
    templateUrl: './list-count.component.html',
    styleUrls: ['./list-count.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ListCountComponent {
  @Input() count: number = 0;
  @Input() selectedLength: number = 0;
  @Input() showSelectedCount: boolean = false;

  readonly T: typeof T = T;
}
